import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import InsuranceSlabForm from './insuranceSlabForm';
import { insuranceSlabEditAction, insuranceSlabSearchAction } from './actions/InsuranceSlabActions';

const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.insuranceSlabManage(),
    },
    {
        title: 'Search',
        link: RoutingUtil.insuranceSlabSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.insuranceSlabManage(),
        component: () => (
            <PermissionHOC
                scope="master.insurance_slab_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
                component={<InsuranceSlabForm />}
            />
        ),
    },
    {
        link: RoutingUtil.insuranceSlabSearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.insurance_slab_manager.search"
                editScope="master.insurance_slab_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="InsuranceSlabReducer"
                dataPath="search"
                editAction={insuranceSlabEditAction}
                redirectUrlOnEdit={RoutingUtil.insuranceSlabManage()}
                action={insuranceSlabSearchAction}
                columns={{
                    slabCode: {
                        display: 'Slab Code',
                        path: 'slabCode',
                      },
                    companyName: {
                        display: 'Company Name',
                        path: "companyId.companyName"
                    },
                    rtoZone: {
                        display: 'RTO State',
                        path: "rtoZone.masterName"
                    },
                    RTOLocation: {
                        display: 'RTO Location',
                        path: "RTOLocation"
                    },
                    policyType: {
                        display: 'Policy Type',
                        path: "policyType.masterName"
                    },
                    fuelType: {
                        display: 'Fuel Type',
                    },
                    ncbValue: {
                        display: 'NCB',
                    },
                    slabRate: {
                        display: 'Slab Type',
                    },
                    isSlabRatePercentage: {
                        display: 'Is Slab Rate in %',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const InsuranceSlabContainer = () => (
    <CrudLayoutContainer
        title="Insurance Slab Manager"
        tabs={tabs}
        routes={routes}
    />
);

InsuranceSlabContainer.propTypes = {
};

export default InsuranceSlabContainer;
